import { Component, OnInit, Inject, ChangeDetectorRef, Input } from '@angular/core';
import { TemperatureInspectionListVM } from '../temperature-inspection.module';
import { TranslateService } from '../../../translate';
import { TemperatureInspectionService } from '../temperature-inspection.service';
import { AppService } from '../../../app.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-temperature-inspection-history-dialog',
  templateUrl: './temperature-inspection-history-dialog.component.html',
  styleUrls: ['./temperature-inspection-history-dialog.component.scss']
})
export class TemperatureInspectionHistoryDialogComponent implements OnInit {

  @Input() TemperatureInspectionList :TemperatureInspectionListVM[]=[];
  @Input() equipmentId:number;
  userLanguage = 'english';
  constructor(
    //public dialogRef: MatDialogRef<TemperatureInspectionHistoryDialogComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private _translate: TranslateService, private _ref: ChangeDetectorRef, 
    private  _temperatureService: TemperatureInspectionService,
    private _router: Router,private _appService: AppService,
    private _sanitizer: DomSanitizer,
) { }

  ngOnInit() {
    // this.TemperatureInspectionList = this.data.TemperatureInspectionList;
    // this.equipmentId =this.data.equipmentId;
  }
  // onNoClick() {
  //   this.dialogRef.close();
  // }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this._ref.detectChanges();
  }
  getImage_(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  HasImage(Id:number){
    return this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.InspectionImage;
  }
  HasComment(Id:number){
    return this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.Note;
  }
  HasWarning(Id:number){
    let leftW= this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.WarningL;
    let RightW= this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.WarningL;
    if((leftW !=null) || (RightW !=null)){
      return true;
    }else{
      return false
    }
  }
  HasDetailComment(Id:number,InspectionDetailId:number,Side:number){
    if(Side==1){
      let com;
      this.TemperatureInspectionList.map(x=>{
        if(x.InspectionSummary.InspectionID == Id){
           com = x.LeftInspectionDetails.find(y=>y.InspectionDetailId == InspectionDetailId)
        }
       })
  
       if(com.Comment !=null){
         return true;
       }
  
    }else{
      let com;
      this.TemperatureInspectionList.map(x=>{
        if(x.InspectionSummary.InspectionID == Id){
           com = x.RightInspectionDetails.find(y=>y.InspectionDetailId == InspectionDetailId)
        }
       })
  
       if(com.Comment !=null){
         return true;
       }
     
    }
   
  }

  GotoFullDetails(inspectionId:number){
    this._router.navigate(['tempinspection', this.equipmentId , inspectionId]);
    //this.dialogRef.close();
  }
 
  getWarning(Id:number){
    let warningL;
    let warningR;
    this.TemperatureInspectionList.map(x=>{
        if(x.InspectionSummary.InspectionID == Id){
           warningL = x.InspectionSummary.WarningL;
           warningR  = x.InspectionSummary.WarningR;
        }
    })
    let WL ='';
    let Final = 'LEFT' + '<br/>' + warningL + '<br/>' + 'RIGHT' + warningR ;
    return Final;
  }
  
  IsMajor(outlier:boolean){
    if(outlier != true){
      return false
    }else{
      return true;
    }
  }
  
  IsMinor(outlier:boolean){
    if(outlier != false){
      return false
    }else{
      return true;
    }
  }
  getEval(val:boolean){
    if(val== true)
    return "major"
    if(val== false)
    return "minor"
    if(val== null)
    return "none"
  }

}
